import React, { useEffect, useState } from 'react';
import './FreebieModal.scss';
import { isExternalLink, safeHtml } from '../../../../services/helpers';
import SvgIcons from '../../../../services/SvgIcons';
import CustomBtn from '../../../../components/CustomBtn/CustomBtn';
import { baseStrapiURL } from '../../../../services/config';

export default function FreebieModal({ content, onClose }) {

    const [link, setLink] = useState('');

    useEffect(() => {
        // Désactiver le scroll du body quand le composant est monté
        document.body.style.overflow = 'hidden';

        // Réactiver le scroll quand le composant est démonté
        return () => {
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        // Définir le lien de téléchargement à partir du contenu
        if (content && content.Remerciements) {
            if (content.Remerciements.PieceJointe.Fichier) {
                setLink(baseStrapiURL + content.Remerciements.PieceJointe.Fichier.url);
            } else if (content.Remerciements.Bouton.LienBouton) {
                setLink(content.Remerciements.Bouton.LienBouton);
            }
        }
    }, [content]);

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className="freebie-modal" onClick={handleOverlayClick}>
            <div className="freebie-modal__content">
                <SvgIcons
                    name={'close'}
                    width={50}
                    height={50}
                    color={'#eee6db'}
                    onClick={onClose}
                    cursor={'pointer'}
                    position={'absolute'}
                    top={10}
                    right={10}
                />
                <div className="freebie-modal__header">
                    <picture className='freebie-modal__logo'>
                        <source srcSet={'/assets/logo_white.webp'} type="image/webp" />
                        <img src={'/assets/logo_white.png'} alt="Logo Grandir & s'élever ensemble" loading="eager" fetchpriority="high" />
                    </picture>
                </div>
                <CustomBtn
                    type={isExternalLink(link) ? 'external' : 'internal'}
                    on_click={onClose}
                    title={content.Remerciements.Bouton.TexteBouton}
                    link={
                        link === null ?
                            ''
                            :
                            (isExternalLink(link) ?
                                link
                                :
                                '/' + link)
                    }
                    bkg_color={'#EEE6DB'}
                    bkg_color_hover={'#EEE6DB'}
                    text_color={'#C08852'}
                    text_color_hover={'#C08852'}
                    border_color={'#EEE6DB'}
                    border_color_hover={'#EEE6DB'}
                    font_family={"Playfair Display"}
                    font_size={'20px'}
                    font_weight={'normal'}
                    border_radius={'10px'}
                    width={'430px'}
                    height={'55px'}
                    margin={'10px 0'}
                    letter_spacing={'2px'}
                    transform={'none'}
                    transform_hover={'translateY(-2px)'}
                    box_shadow={'none'}
                    box_shadow_hovered={'0 6px 20px rgba(0, 0, 0, 0.2)'}
                />
                <div className="freebie-modal__tanks_text" dangerouslySetInnerHTML={safeHtml(content.Remerciements.Texte)} />
                <p className="freebie-modal__privacy">
                    Ton adresse email ne sera jamais partagée
                </p>
            </div>
        </div>
    );
}